import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-dark text-primary-foreground">
      <div className="container-padding mx-auto section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="/logo-godoy-aguiar.png" 
                alt="Godoy & Aguiar - Sociedade de Advogados" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Escritório especializado em direito tributário e previdenciário com compromisso e excelência
              na defesa dos seus direitos.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-light hover:bg-accent flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-light hover:bg-accent flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-light hover:bg-accent flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/sobre-nos"
                  className="text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                >
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link
                  to="/servicos"
                  className="text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                >
                  Serviços
                </Link>
              </li>
              <li>
                <Link
                  to="/artigos"
                  className="text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                >
                  Artigos
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Áreas de Atuação</h4>
            <ul className="space-y-2">
              <li className="text-primary-foreground/80 text-sm">Direito Previdenciário</li>
              <li className="text-primary-foreground/80 text-sm">Direito Trabalhista</li>
              <li className="text-primary-foreground/80 text-sm">Direito Tributário</li>
              <li className="text-primary-foreground/80 text-sm">Aposentadorias</li>
              <li className="text-primary-foreground/80 text-sm">BPC/LOAS</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="fas fa-map-marker-alt text-accent mt-1"></i>
                <div className="text-primary-foreground/80 text-sm">
                  <div className="mb-3">
                    <p className="font-semibold mb-1">Cabo Frio/RJ:</p>
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Avenida+Independência,+32,+2°+andar,+sala+15,+Unamar,+Cabo+Frio,+RJ,+28928-542"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-accent transition-colors"
                    >
                      Avenida Independência, n° 32, 2° andar, sala 15<br />
                      Unamar, Cabo Frio/RJ<br />
                      CEP: 28928-542
                      <i className="fas fa-external-link-alt ml-1 text-xs"></i>
                    </a>
                  </div>
                  <div>
                    <p className="font-semibold mb-1">Rio de Janeiro/RJ:</p>
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Estrada+do+Piaí,+5521,+loja,+Sepetiba,+Rio+de+Janeiro,+RJ,+23530-661"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-accent transition-colors"
                    >
                      Estrada do Piaí, n° 5521, loja<br />
                      Sepetiba, Rio de Janeiro/RJ<br />
                      CEP: 23530-661
                      <i className="fas fa-external-link-alt ml-1 text-xs"></i>
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <i className="fas fa-phone text-accent"></i>
                <a
                  href="tel:+5522998342742"
                  className="text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                >
                  (22) 99834-2742
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="fas fa-envelope text-accent"></i>
                <a
                  href="mailto:godoyaguiarsda@gmail.com"
                  className="text-primary-foreground/80 hover:text-accent transition-colors text-sm"
                >
                  godoyaguiarsda@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-primary-foreground/60 text-sm text-center md:text-left">
              © {currentYear} GODOY & AGUIAR Advocacia. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6">
              <Link
                to="/privacidade"
                className="text-primary-foreground/60 hover:text-accent transition-colors text-sm"
              >
                Política de Privacidade
              </Link>
              <Link
                to="/termos"
                className="text-primary-foreground/60 hover:text-accent transition-colors text-sm"
              >
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;